import { Controller } from "@hotwired/stimulus"

// One message: local time, and the edit/delete actions switched on for the
// author (edit, delete) and the room admins (delete). The server enforces
// the same rules.
export default class extends Controller {
  static targets = ["time", "own", "deletable"]
  static values = { creatorId: Number, url: String }

  connect() {
    const me = Number(document.body.dataset.userId)
    const own = this.creatorIdValue === me
    const admin = this.element.closest("[data-chat-room-admin-value='true']") !== null
    this.ownTargets.forEach((el) => (el.hidden = !own))
    this.deletableTargets.forEach((el) => (el.hidden = !(own || admin)))
    if (this.hasTimeTarget) {
      const at = new Date(this.timeTarget.getAttribute("datetime"))
      this.timeTarget.textContent = at.toLocaleTimeString(document.documentElement.lang || undefined, { hour: "2-digit", minute: "2-digit" })
    }
  }

  copyLink() {
    const url = new URL(this.urlValue, window.location.origin).toString()
    navigator.clipboard?.writeText(url)
  }

  // Mobile: a tap on the message toggles its action row. Ignore taps on
  // links, buttons and inside the boost popover so they keep working.
  tapActions(event) {
    if (event.target.closest("a, button, input, .chat-boost-picker, .chat-msg__actions")) return
    this.element.classList.toggle("chat-msg--open")
  }
}
